import React, { useRef } from 'react';

import TextField from '@material-ui/core/TextField'

import makeFilters from '../../../app/common/RegexFilters';

const SearchInput = ({ criteria = '', label = 'Search', variant = 'standard', onChange }) => {
    const criteriaRef = useRef(criteria);

    const handleChange = () => onChange(makeFilters(criteriaRef.current?.value));

    return (
        <div>
            <TextField
                id="search-input"
                label={label}
                inputRef={criteriaRef}
                defaultValue={criteria}
                onChange={handleChange}
                variant={variant}
            />
        </div>
    );
};

export default SearchInput;